<form [formGroup]="form" (ngSubmit)="save()">
    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#ffecda;"><img src="assets/img/icons/section-regimen-contratacion.svg" alt=""></span>
            <h5>Régimen de contratación</h5>
            <button type="button" class="tab-inline-badge-btn" (click)="openRegimeDetailsModal()">Detalle del régimen</button>
        </div>
        <div class="field-row">
            <div class="field-col" style="flex-basis: 100%;">
                <label class="field-label">Régimen para recibos electrónicos</label>
                <select class="field-select" formControlName="tax_regime">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let r of taxRegimes" [value]="r">{{r}}</option>
                </select>
            </div>
        </div>
        <div class="field-row">
            <div class="field-col" style="flex-basis: 100%;">
                <label class="field-label">Detalles del régimen</label>
                <textarea class="field-textarea" formControlName="tax_regime_details" [maxlength]="maxTaxRegimeDetailsLength"
                    placeholder="Describe o agrega detalles del régimen..."></textarea>
                <div class="field-char-count">{{form.get('tax_regime_details')?.value?.length || 0}} / {{maxTaxRegimeDetailsLength}}</div>
            </div>
        </div>
    </div>

    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#defedb;"><img src="assets/img/icons/section-datos-contrato.svg" alt=""></span>
            <h5>Datos del contrato</h5>
        </div>
        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Identidad federativa donde se presta el servicio</label>
                <select class="field-select" formControlName="service_federal_entity">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let s of states" [value]="s">{{s}}</option>
                </select>
            </div>
            <div class="field-col">
                <label class="field-label">Tipo de contrato</label>
                <select class="field-select" formControlName="contract_type">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let c of contractTypes" [value]="c">{{c}}</option>
                </select>
            </div>
        </div>
        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Tipo de jornada</label>
                <select class="field-select" formControlName="work_schedule_type">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let w of workScheduleTypes" [value]="w">{{w}}</option>
                </select>
            </div>
            <div class="field-col">
                <label class="field-label">Tipo de empleado</label>
                <select class="field-select" formControlName="employee_type">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let e of employeeTypes" [value]="e">{{e}}</option>
                </select>
            </div>
        </div>
    </div>

    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#d4dbff;"><img src="assets/img/icons/section-plantillas.svg" alt=""></span>
            <h5>Plantillas</h5>
        </div>
        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Plantilla personalizada por el trabajador</label>
                <input type="text" class="field-input" formControlName="custom_template" placeholder="Selecciona una plantilla (opcional)">
            </div>
        </div>
    </div>

    <div class="tab-save-bar" *ngIf="canDo('Editar')">
        <button type="submit" class="btn btn-primary">Guardar cambios</button>
    </div>
</form>

<div class="modal fade" id="regimeDetailsModal" tabindex="-1" aria-hidden="true" [formGroup]="regimeDetailsDraftForm">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content p-2 p-md-3">
            <div class="modal-header border-0">
                <h5 class="modal-title mx-auto fw-bold">Régimen de contratación</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="d-flex gap-3 flex-wrap align-items-stretch mb-3">
                    <div class="regime-option-card flex-fill" style="min-width: 280px;">
                        <label class="field-label">Tipo de ingreso (Inscripción al RFC)</label>
                        <div class="regime-checkbox-list">
                            <div class="regime-checkbox-row" *ngFor="let opt of incomeTypeOptions">
                                <input type="checkbox" [id]="'income_' + opt" [checked]="regimeDetailsDraftForm.value.income_type === opt"
                                    (change)="setIncomeType(opt)">
                                <label [for]="'income_' + opt">{{opt}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="regime-option-card" style="min-width: 200px;">
                        <label class="field-label">Gravable</label>
                        <div class="regime-checkbox-list">
                            <div class="regime-checkbox-row">
                                <input type="checkbox" id="taxable_isr" formControlName="taxable_isr">
                                <label for="taxable_isr">ISR</label>
                            </div>
                            <div class="regime-checkbox-row">
                                <input type="checkbox" id="taxable_imss" formControlName="taxable_imss">
                                <label for="taxable_imss">IMSS</label>
                            </div>
                            <div class="regime-checkbox-row">
                                <input type="checkbox" id="taxable_employment_subsidy" formControlName="taxable_employment_subsidy">
                                <label for="taxable_employment_subsidy">Subs. Empleo</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex gap-3 flex-wrap">
                    <div class="field-col flex-fill" style="min-width: 240px;">
                        <label class="field-label">Ingreso anual estimado<br>Alta del trabajador</label>
                        <div class="field-input-plain" style="border:1px solid #dbdbdb;">
                            <input type="number" step="0.01" formControlName="estimated_annual_income_hire">
                            <i class="ti ti-calculator"></i>
                        </div>
                    </div>
                    <div class="field-col flex-fill" style="min-width: 240px;">
                        <label class="field-label">Ingreso anual estimado<br>Baja del trabajador</label>
                        <div class="field-input-plain" style="border:1px solid #dbdbdb;">
                            <input type="number" step="0.01" formControlName="estimated_annual_income_termination">
                            <i class="ti ti-calculator"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer border-0 justify-content-center">
                <button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" *ngIf="canDo('Editar')" (click)="saveRegimeDetails()">Aceptar</button>
            </div>
        </div>
    </div>
</div>
